// Extended mock data for task and timesheet management

export const mockTasks = [
  {
    id: 1,
    tutor: 'Dr. Priya Sharma',
    tutorId: 1,
    parent: 'Mrs. Kumar',
    student: 'Rahul Kumar',
    studentId: 1,
    subject: 'Mathematics',
    billingRate: 600, // per hour
    payoutRate: 400, // per hour
    status: 'active',
    startDate: '2025-01-01',
    createdDate: '2024-12-28',
    // For task management view
    title: 'Math Tutoring - Rahul Kumar',
    description: 'Regular mathematics tutoring sessions',
    dueDate: '2025-01-31',
    priority: 'high',
    assignedTo: 'Dr. Priya Sharma',
    category: 'Tutoring',
    completed: false
  },
  {
    id: 2,
    tutor: 'Prof. Rajesh Verma',
    tutorId: 2,
    parent: 'Mr. Patel',
    student: 'Ananya Patel',
    studentId: 2,
    subject: 'Physics',
    billingRate: 700,
    payoutRate: 450,
    status: 'active',
    startDate: '2025-01-01',
    createdDate: '2024-12-30',
    title: 'Physics Tutoring - Ananya Patel',
    description: 'Physics sessions for Grade 11',
    dueDate: '2025-01-31',
    priority: 'medium',
    assignedTo: 'Prof. Rajesh Verma',
    category: 'Tutoring',
    completed: false
  },
  {
    id: 3,
    tutor: 'Dr. Meera Iyer',
    tutorId: 3,
    parent: 'Mrs. Reddy',
    student: 'Arjun Reddy',
    studentId: 3,
    subject: 'Chemistry',
    billingRate: 650,
    payoutRate: 420,
    status: 'active',
    startDate: '2025-01-05',
    createdDate: '2025-01-02',
    title: 'Chemistry Tutoring - Arjun Reddy',
    description: 'Board exam preparation for Chemistry',
    dueDate: '2025-02-15',
    priority: 'high',
    assignedTo: 'Dr. Meera Iyer',
    category: 'Tutoring',
    completed: false
  }
];

export const mockTimesheets = [
  {
    id: 1,
    taskId: 1,
    tutorId: 1,
    tutor: 'Dr. Priya Sharma',
    student: 'Rahul Kumar',
    subject: 'Mathematics',
    date: '2025-01-10',
    hours: 2,
    minutes: 0,
    notes: 'Covered quadratic equations and problem solving',
    billAmount: 1200, // 2 * 600
    payoutAmount: 800, // 2 * 400
    status: 'approved',
    createdDate: '2025-01-10',
    // For admin view
    employee: 'Dr. Priya Sharma',
    hoursWorked: 2,
    description: 'Math session - Quadratic equations'
  },
  {
    id: 2,
    taskId: 1,
    tutorId: 1,
    tutor: 'Dr. Priya Sharma',
    student: 'Rahul Kumar',
    subject: 'Mathematics',
    date: '2025-01-12',
    hours: 1,
    minutes: 30,
    notes: 'Practice session - trigonometry basics',
    billAmount: 900, // 1.5 * 600
    payoutAmount: 600, // 1.5 * 400
    status: 'approved',
    createdDate: '2025-01-12',
    employee: 'Dr. Priya Sharma',
    hoursWorked: 1.5,
    description: 'Math session - Trigonometry'
  },
  {
    id: 3,
    taskId: 2,
    tutorId: 2,
    tutor: 'Prof. Rajesh Verma',
    student: 'Ananya Patel',
    subject: 'Physics',
    date: '2025-01-11',
    hours: 2,
    minutes: 0,
    notes: 'Newton\'s laws of motion - theory and applications',
    billAmount: 1400, // 2 * 700
    payoutAmount: 900, // 2 * 450
    status: 'approved',
    createdDate: '2025-01-11',
    employee: 'Prof. Rajesh Verma',
    hoursWorked: 2,
    description: 'Physics session - Newton\'s Laws'
  },
  {
    id: 4,
    taskId: 3,
    tutorId: 3,
    tutor: 'Dr. Meera Iyer',
    student: 'Arjun Reddy',
    subject: 'Chemistry',
    date: '2025-01-13',
    hours: 1,
    minutes: 45,
    notes: 'Chemical bonding and molecular structure',
    billAmount: 1137.5, // 1.75 * 650
    payoutAmount: 735, // 1.75 * 420
    status: 'pending',
    createdDate: '2025-01-13',
    employee: 'Dr. Meera Iyer',
    hoursWorked: 1.75,
    description: 'Chemistry session - Chemical Bonding'
  }
];

export const mockMonthlyInvoiceData = {
  'Mrs. Kumar': {
    parent: 'Mrs. Kumar',
    student: 'Rahul Kumar',
    month: 'January 2025',
    tasks: [
      { taskId: 1, subject: 'Mathematics', sessions: 2, totalHours: 3.5, amount: 2100 }
    ],
    totalAmount: 2100,
    discount: 0,
    finalAmount: 2100
  },
  'Mr. Patel': {
    parent: 'Mr. Patel',
    student: 'Ananya Patel',
    month: 'January 2025',
    tasks: [
      { taskId: 2, subject: 'Physics', sessions: 1, totalHours: 2, amount: 1400 }
    ],
    totalAmount: 1400,
    discount: 0,
    finalAmount: 1400
  },
  'Mrs. Reddy': {
    parent: 'Mrs. Reddy',
    student: 'Arjun Reddy',
    month: 'January 2025',
    tasks: [
      { taskId: 3, subject: 'Chemistry', sessions: 1, totalHours: 1.75, amount: 1137.5 }
    ],
    totalAmount: 1137.5,
    discount: 0,
    finalAmount: 1137.5
  }
};

// Helper functions
export const calculateBillAmount = (hours, minutes, billingRate) => {
  const totalHours = hours + minutes / 60;
  return totalHours * billingRate;
};

export const calculatePayoutAmount = (hours, minutes, payoutRate) => {
  const totalHours = hours + minutes / 60;
  return totalHours * payoutRate;
};

export const getTutorTimesheets = (tutorId) => {
  return mockTimesheets.filter(ts => ts.tutorId === tutorId);
};

export const getTutorTasks = (tutorId) => {
  return mockTasks.filter(task => task.tutorId === tutorId && task.status === 'active');
};

export const getTutorMonthlyPayout = (tutorId, month, year) => {
  const tutorTimesheets = mockTimesheets.filter(
    ts => ts.tutorId === tutorId && 
    ts.status === 'approved' &&
    new Date(ts.date).getMonth() === month &&
    new Date(ts.date).getFullYear() === year
  );
  return tutorTimesheets.reduce((sum, ts) => sum + ts.payoutAmount, 0);
};

export const getParentMonthlyBill = (parent, month, year) => {
  // Filter timesheets for this parent's students in the given month
  const relevantTasks = mockTasks.filter(task => task.parent === parent);
  const taskIds = relevantTasks.map(t => t.id);
  
  const timesheets = mockTimesheets.filter(
    ts => taskIds.includes(ts.taskId) &&
    ts.status === 'approved' &&
    new Date(ts.date).getMonth() === month &&
    new Date(ts.date).getFullYear() === year
  );
  
  return timesheets.reduce((sum, ts) => sum + ts.billAmount, 0);
};
